import { render, staticRenderFns } from "./PaginationCom.vue?vue&type=template&id=d7bc3c5c&"
import script from "./PaginationCom.vue?vue&type=script&lang=js&"
export * from "./PaginationCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports